











import {Component, Watch} from 'vue-property-decorator';
import PickerBase from './base';
import userSettingsApi from '@/views/settings/general/api';

@Component
export default class Direction extends PickerBase {
  silent: boolean = true;
  param: string = 'orderDir';
  value: string = 'asc';

  data: { value: string; text: string }[] = [
    {
      value: 'asc',
      text: this.t('Ascending')
    },
    {
      value: 'desc',
      text: this.t('Descending')
    }
  ];

  get icon() {
    return this.value === 'asc'
      ? 'fas fa-sort-amount-up'
      : 'fas fa-sort-amount-down';
  }

  created() {
    this.value = this.$store.state.user.dashboardDefaultOrderDir as any || 'asc';
    this.cache(true);
  }

  @Watch('value')
  setDirection(val: string) {
    this.cache();
    // this.$store.commit('dashboardDirection', val);
    // userSettingsApi.put({dashboardDefaultOrderDir: val}).then(()=>{
    //   console.log('Dashboard:', 'settings were saved');
    // });
  }
}
